import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Country.requests'
import {
    Country,
} from '../Countries.types'

export default (ids: number[]) => {
    return useRequest<Country[]>({
        key: RequestKeys.getCountriesByIds,
        params: {
            includeFilters: {
                id: ids,
            },
        },
        requestFunc: RequestFn.getEntity(config.getAll, (promise) => {
            return promise.then((resp) => {
                return resp?.data?.items
            })
        }),
        keepPreviousData: true,
        enabled: Boolean(ids.length),
    })
}
